<template>
  <section class="recruiters-section">
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap justify-center text-center mb-10">
        <div class="w-full lg:w-6/12 px-4">
          <h2 class="text-4xl font-semibold text-white">Our key Recruiters</h2>
        </div>
      </div>
      <v-carousel class="mb-2" :items-to-show="4.5" :autoplay="3000" :wrapAround="true" :transition="3000"
                  style="height: auto">
        <v-slide v-for="(recruiter, index) in logos" :key="index">
          <recruiter-card :logo="recruiter"></recruiter-card>
        </v-slide>
      </v-carousel>
    </div>
  </section>
</template>

<script>
import {Carousel as VCarousel, Slide as VSlide} from 'vue3-carousel';
import RecruiterCard from "@/components/RecruiterCard";

export default {
  name: "KeyRecruiters",
  components: {
    VCarousel,
    VSlide,
    RecruiterCard
  },
  data() {
    return {
      logos: ['adani', 'Astral tech', 'barclays', 'battrix', 'bharat', 'Bosch', 'Capgemini', 'CArigar', 'Cogniz',
        'CTR', 'Datamatics', 'dhoot', 'endurance', 'infosys', 'john deere', 'Kalyani', 'L&T', 'Metaforge', 'qspider', 'sankay',
        'shree', 'SIEMENS Logo', 'suzlon', 'tata', 'tata strive', 'tata_advanced_logo', 'Triarq', 'webt', 'Winjit', 'Wipro', 'Zensr'
      ]
    }
  }
}
</script>

<style scoped>

</style>
